import types from './types'
import Vue from 'vue'

/*
    Handle all the resource "Areas / Common Presentations"
*/
const setAreas = (state, areas) => state.areas = areas
const updateArea = (state, { data, areaInd }) => Vue.set(state.areas, areaInd, data)

/*
    Set filters based on resources
*/
const buildGlobalFilters = (state, filters) => filters.forEach(filter => {
    if (!state.searchFilters[filter]) Vue.set(state.searchFilters, filter, [])
})
const setSearchFilters = (state, { name, newVal }) => Vue.set(state.searchFilters, name, newVal)

/*
    Handle all multiple download / zipping actions
*/
const addToZip = (state, file) => state.zipFiles = [...state.zipFiles, file]
const removeFromZip = (state, id) => state.zipFiles = state.zipFiles.filter(file => file.id !== id)
const clearZipSelections = state => state.zipFiles = []

/*
    Handle Search
*/
const setSearchResults = (state, documents) => state.searchResults = documents
const setSearchError = (state, error) => state.searchError = error
const setLoading = (state, bool) => state.loadingResults = bool

/*
    Handle video modal resource
*/
const setVideoUrl = (state, url) => {
    state.videoModalOpen = true
    state.videoURL = url
}
const closeVideo = state => {
    state.videoModalOpen = false
    state.videoURL = null
}

/*
    Handle resource editing
*/
const toggleResourceEditing = (state, bool) => {
    state.editingResource = bool
    bool ? state.lockTabs = true : state.lockTabs = false
}
const setEditingData = (state, resource) => state.editingResourceData = resource

const updateResource = (state, { data, areaResource, searchResource }) => {
    const hasAreaResource = areaResource && areaResource.areaResourceIndex && areaResource.areaResourceIndex !== -1
    const hasSearchResource = searchResource && searchResource !== -1

    if (hasAreaResource) Vue.set(state.areas[areaResource.areaIndex].resources, areaResource.areaResourceIndex, data)
    if (hasSearchResource) Vue.set(state.searchResults, searchResource, data)
}

const unlockVuexTabs = state => state.lockTabs = false

const setAreaResources = (state, { ind, documents }) => {
    Vue.set(state.areas[ind], 'resources', documents)
}

const deleteResource = (state, { searchResultIndex, areas }) => {
    if (searchResultIndex !== -1) Vue.delete(state.searchResults, searchResultIndex)
    if (areas !== -1 && areas && areas.length > 1) {
        Vue.delete(state.areas[areas.area].resources, areas.resource)
    }
}

export default {
    [types.SET_AREAS]: setAreas,
    [types.UPDATE_AREA]: updateArea,
    [types.BUILD_FILTERS]: buildGlobalFilters,
    [types.SET_SEARCH_FILTERS]: setSearchFilters,
    [types.ADD_TO_ZIP]: addToZip,
    [types.REMOVE_FROM_ZIP]: removeFromZip,
    [types.CLEAR_ZIP_SELECTIONS]: clearZipSelections,
    [types.SET_LOADING]: setLoading,
    [types.SET_SEARCH_RESULTS]: setSearchResults,
    [types.SET_SEARCH_ERROR]: setSearchError,
    [types.PLAY_VIDEO]: setVideoUrl,
    [types.CLOSE_VIDEO]: closeVideo,
    [types.SET_EDITING_RESOURCE]: toggleResourceEditing,
    [types.UPDATE_RESOURCE]: updateResource,
    [types.SET_EDITING_RESOURCE_DATA]: setEditingData,
    [types.UNLOCK_TABS]: unlockVuexTabs,
    [types.SET_AREA_RESOURCES]: setAreaResources,
    [types.DELETE_RESOURCE]: deleteResource
}
